import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";

export default function AgentNetwork() {
  const [data, setData] = useState(null);
  const [threeGen, setThreeGen] = useState(null);
  useEffect(() => {
    api.get("/agent/network").then((r) => setData(r.data)).catch(() => {});
    api.get("/v2/referral/status").then((r) => setThreeGen(r.data)).catch(() => {});
    api.get("/v2/referral/network").then((r) => setThreeGen((s) => ({ ...(s || {}), network: r.data }))).catch(() => {});
  }, []);
  if (!data) return <div className="text-gray-400">Caricamento…</div>;
  const status = threeGen?.status;
  const rates = threeGen?.rates;
  const next = threeGen?.next;
  const buckets = threeGen?.earnings_by_generation || {};
  const gcounts = threeGen?.network?.generations || {};
  return (
    <div className="space-y-6 fade-slide" data-testid="agent-network">
      <h1 className="text-3xl font-bold text-[#0A0A0A]">Rete Agenti</h1>
      {status && (
        <div className="vg-card p-6" data-testid="ref3gen-status">
          <div className="flex flex-wrap items-baseline justify-between gap-3">
            <div>
              <p className="text-xs font-semibold uppercase tracking-wide text-gray-400">Status</p>
              <p className="text-3xl font-bold text-[#B40101]" style={{ fontFamily: "Outfit" }}>{status}</p>
              <p className="text-xs text-gray-500 mt-1">{threeGen.direct_active_count} diretti attivi</p>
            </div>
            <div className="text-right">
              {next?.next_status ? (
                <p className="text-sm text-gray-500">
                  Mancano <strong className="text-[#0A0A0A]">{Math.max(0, next.needed_for_next)}</strong> diretti per {next.next_status}
                </p>
              ) : (
                <p className="text-sm text-gray-500">Top status raggiunto</p>
              )}
              <p className="text-xs text-gray-400 mt-1">
                Aliquote: 1ª {(rates?.g1 * 100).toFixed(0)}% · 2ª {(rates?.g2 * 100).toFixed(0)}% · 3ª {(rates?.g3 * 100).toFixed(0)}%
              </p>
            </div>
          </div>
          <div className="grid grid-cols-3 gap-4 mt-4">
            {[1, 2, 3].map((g) => (
              <div key={g} className="rounded-md border border-gray-100 p-3">
                <p className="text-xs font-semibold uppercase tracking-wide text-gray-400">Gen {g}</p>
                <p className="text-sm text-gray-600 mt-1">{gcounts[g]?.counts?.active ?? 0} attivi / {gcounts[g]?.counts?.total ?? 0} totali</p>
                <p className="text-xs text-gray-500 mt-1">
                  ACCRUED €{(buckets[g]?.ACCRUED ?? 0).toFixed(2)} · PAID €{(buckets[g]?.PAID ?? 0).toFixed(2)}
                </p>
              </div>
            ))}
          </div>
        </div>
      )}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <Card label="Totale rete" value={data.totale_rete} />
        <Card label="Referral attivi" value={data.referral_attivi} sub="≥ 60 giorni & sottoscritto" />
        <Card label="Fee maturata" value={`€${data.fee_maturata.toFixed(2)}`} sub={`Scaglione ${data.percentuale_scaglione}%${data.ruolo === "fpa" ? " (FPA)" : ""}`} />
      </div>
      <div className="vg-card overflow-hidden">
        <div className="p-4 border-b border-gray-100 bg-gray-50">
          <h3 className="font-bold text-[#0A0A0A]">Agenti reclutati</h3>
        </div>
        {data.agents.length === 0 ? (
          <div className="p-8 text-center text-gray-500">Non hai ancora reclutato nessun agente. Condividi il tuo link per costruire la rete.</div>
        ) : (
          <table className="w-full text-sm">
            <thead className="bg-gray-50 text-xs uppercase text-gray-500">
              <tr><th className="px-4 py-3 text-left">Nome</th><th className="px-4 py-3 text-left">Email</th><th className="px-4 py-3">Giorni</th><th className="px-4 py-3">Status</th><th className="px-4 py-3">Attivo</th></tr>
            </thead>
            <tbody>
              {data.agents.map((a) => (
                <tr key={a.id} className="border-t border-gray-100">
                  <td className="px-4 py-3 font-semibold text-[#0A0A0A]">{a.nome} {a.cognome}</td>
                  <td className="px-4 py-3 text-gray-600">{a.email}</td>
                  <td className="px-4 py-3 text-center">{a.giorni_attivo}</td>
                  <td className="px-4 py-3 text-center">{a.subscription_status}</td>
                  <td className="px-4 py-3 text-center">{a.is_active_referral ? <span className="text-[#10B981]">✓</span> : <span className="text-gray-300">—</span>}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}

function Card({ label, value, sub }) {
  return (
    <div className="vg-card p-6">
      <p className="text-xs font-semibold uppercase tracking-wide text-gray-400">{label}</p>
      <p className="text-3xl font-bold text-[#0A0A0A] mt-1" style={{ fontFamily: "Outfit" }}>{value}</p>
      {sub && <p className="text-xs text-gray-500 mt-1">{sub}</p>}
    </div>
  );
}
